import { IKnmErknmFormOrganizationAdd } from '../interfaces/IKnmErknmFormOrganizationAdd';
import { IKnmErknmOrganizationTemplateSelectOption } from '../interfaces/IKnmErknmOrganizationTemplateSelectOption';
import { createOrganizationTemplateSelectOption } from './createOrganizationTemplateSelectOption';

export const createOrganizationTemplateSelectOptionFromDocument = (
  documentOrganizationTemplate: IKnmErknmOrganizationTemplateSelectOption | undefined,
  documentOrganization: IKnmErknmFormOrganizationAdd | undefined,
): IKnmErknmOrganizationTemplateSelectOption | undefined => {
  if (
    documentOrganizationTemplate &&
    (documentOrganization?.inn || documentOrganization?.ogrn || documentOrganization?.organizationName)
  ) {
    return createOrganizationTemplateSelectOption(documentOrganization);
  }
};
